import React, { Suspense } from 'react';
import {
  I18nextProvider as DefaultI18nextProvider,
  type I18nextProviderProps,
} from 'react-i18next';

export const I18nProvider: React.FC<I18nextProviderProps> = ({
  children,
  ...props
}) => (
  <DefaultI18nextProvider {...props}>
    <Suspense fallback={null}>{children}</Suspense>
  </DefaultI18nextProvider>
);
